/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class DevicesResource {
  private readonly uri = ApiConfig.obtain().getVersionedUri('devices');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get() {
    return this.send({
      method: 'GET',
      url: this.uri,
      params: {context: null}
    }).then(function(data) {
      const props = {};
      _.forEach(data.results, function(group) {
        props[group.group] = _.map(group.properties, 'value').sort();
      });
      return props;
    });
  }
}
